
export default class PageState {

}
